import React from 'react';
import SuggestionGroupSection from '../SuggestionGroupSection';
import { SuggestionsListContainer, EmptyState, LoadingContainer } from './SuggestionsList.styled';
import { CircularProgress, Typography } from '@ann/web-components';

const SuggestionsList = ({ 
  groups = [], 
  loading = false,
  onApprove,
  onDecline,
  expandedGroups = {},
  onToggleGroup,
}) => {
  if (loading) {
    return (
      <SuggestionsListContainer>
        <LoadingContainer>
          <CircularProgress size="xl" />
        </LoadingContainer>
      </SuggestionsListContainer>
    );
  }

  if (groups.length === 0) {
    return (
      <SuggestionsListContainer>
        <EmptyState>
          <Typography category="body" size="medium" color="body">
            No suggestions available
          </Typography>
        </EmptyState>
      </SuggestionsListContainer>
    );
  }

  return (
    <SuggestionsListContainer>
      {groups.map((group) => (
        <SuggestionGroupSection
          key={group.id}
          group={group}
          isExpanded={expandedGroups[group.id] || false}
          onToggle={() => onToggleGroup?.(group.id)}
          onApprove={onApprove}
          onDecline={onDecline}
        />
      ))}
    </SuggestionsListContainer>
  );
};

export default SuggestionsList;

